/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForIdentityOntologySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForIdentityOntologySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForIdentityOntologySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForIdentityOntologySync>): BackgroundJobPayloadForIdentityOntologySync {
        let obj = Object.assign(new BackgroundJobPayloadForIdentityOntologySync(), model);
        BackgroundJobPayloadForIdentityOntologySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForIdentityOntologySync>): BackgroundJobPayloadForIdentityOntologySync {
        if (!model) return null;
        return BackgroundJobPayloadForIdentityOntologySync.newInstance(<BackgroundJobPayloadForIdentityOntologySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForIdentityOntologySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForIdentityOntologySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForIdentityOntologySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForIdentityOntologySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack master account whose Identity data is (re)projected into GraphDB (repo + named-graph scope).
     */
    master_account_id: string;

}
